module.exports = __webpack_public_path__ + "static/Aeroseal_Building_Commercial-42e49186d2bbd3e6d51884570cbac0eb.png";